import React from "react";
import HomepageSecondaryLayout from "../../../components/homepages/homepageSecondaryLayout.tsx";
import colors from "../../../constants/colors.ts";
import Section2 from "./Section2.app.tsx";

const Section1: React.FC = () => {
  return (
    <HomepageSecondaryLayout
      backgroundColor={colors.BLUE_DDEFFF}
      title={"TITLE.MaxRelaxMassageProgram"}
      button={"BUTTON.FindOutMore"}
      media={'Secondary-Homepage-Image-Layout'}
    >
      <Section2 />
    </HomepageSecondaryLayout>
  );
};

export default Section1;
